import { State as RootState } from "@/store";
import { GetterTree } from "vuex";
import { State as LocalState } from "./state";
import { CountryAddress } from "@/configs/jtTypes";
import { Order } from "@/configs/orders";
import { AddressMode } from "@/libs/address";

// Getters types
export type Getters = {
  darkMode(state: LocalState): boolean;
  countryAddresses(state: LocalState): CountryAddress[];
  orderLibrary(state: LocalState): Order[];
  addressMode(state: LocalState): AddressMode;
};

// Getters
export const getters: GetterTree<LocalState, RootState> & Getters = {
  darkMode: (state) => {
    return state.darkMode;
  },
  countryAddresses: (state) => {
    return state.countryAddresses;
  },
  orderLibrary: (state) => {
    return state.orderLibrary;
  },
  addressMode: (state) => {
    return state.addressMode;
  },
};
